/* Define your initial state here.
 *
 * If you change the type from object to something else, do not forget to update
 * src/container/App.js accordingly.
 */
import { NAVIGATE, DISMISS_SIDENAV_ANNOUNCEMENT } from '../../ActionsConst';

const initialState = {
  activeNav: 'home',
  displaySideNavAnnouncement: localStorage.getItem('userDismissedSideNavAnnouncement') !== 'true',
};

/**
 * From a given url, work out which "navigation" item is currently active
 * @param {string} url
 * @returns {string}
 */
function urlToNav(url) {
  // If the url starts with a '/', remove it. Then remove the next '/' and everything after it.
  // eg /nav-we-care-about/stuff-we-don't-care-about => nav-we-care-about
  const reducedUrl = url.replace(/^\//, '').replace('/.*/', '');
  return reducedUrl;
}

const sideNavigation = (state = initialState, action) => {
  switch (action.type) {
    case NAVIGATE:
      return { ...state, activeNav: urlToNav(action.url) };
    case DISMISS_SIDENAV_ANNOUNCEMENT:
      return { ...state, displaySideNavAnnouncement: false };
    default: {
      return state;
    }
  }
};

export default sideNavigation;
